import {
  HeroMetric,
  HeroMetricProps,
} from '@features/campaigns/components/Summary/HeroMetric';
import { faDollar } from '@fortawesome/pro-solid-svg-icons';
import { formatters } from '@utils/formattersV2';

export const AdSpendHeroMetric = (
  props: Pick<HeroMetricProps, 'value' | 'colorScheme'>
) => {
  return (
    <HeroMetric
      value={props.value}
      label="Ad Spend"
      icon={faDollar}
      valueFormatter={value =>
        formatters.currency(value, { full: true, decimals: 0 })
      }
      colorScheme={props.colorScheme}
      data-testid="ad-spend"
    />
  );
};
